import React from 'react';
import PageContext from '../context/page.js';

export default function PageProvider(props) {
	let { pageContext, children } = props;

	return <PageContext.Provider value={pageContext}>{children}</PageContext.Provider>;
}
